import Heading from 'LuxKit/Typography/Heading'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'

import Pane from 'components/Common/Pane'
import LayoutContainer from 'components/Common/LayoutContainer'
import ValuePropositionItems from 'marketing/pages/ContentfulWebPage/ValuePropositionItems'

const StyledLayoutContainer = styled(LayoutContainer)`
  padding-top: ${rem(40)};
  padding-bottom: ${rem(40)};
`

interface Props {
  items: Array<App.ComponentValuePropositionBlock>
  title: string
}

function ContentfulValuePropositionBanner(props: Props) {
  const { items, title } = props

  return (
    <Pane>
      <StyledLayoutContainer>
        <VerticalSpacer gap={40}>
          <Heading variant="heading2">{title}</Heading>
          <ValuePropositionItems values={items} />
        </VerticalSpacer>
      </StyledLayoutContainer>
    </Pane>
  )
}

export default ContentfulValuePropositionBanner
